import styled from 'styled-components';
import { ProgressStepperCurrentLabelMixin } from '../../mixins/components/ProgressStepperCurrentLabelMixin';
import { ProgressStepperStepLabel } from '../ProgressStepperStepLabel/ProgressStepperStepLabel';

/**
 * Used by `ProgressStepper` when only showing the label for the current step.
 *
 * It's the same as a `ProgressStepperStepLabel` but a separate component so that
 * `ProgressStepper` can control its visibility separately.
 *
 * @extends ProgressStepperStepLabel
 * @since 8.57.0
 */
var ProgressStepperCurrentLabel = /*#__PURE__*/styled(ProgressStepperStepLabel).withConfig({
  displayName: "ProgressStepperCurrentLabel",
  componentId: "c11n-8-111-1__sc-6abryx-0"
})(["", ""], ProgressStepperCurrentLabelMixin);
ProgressStepperCurrentLabel.displayName = 'ProgressStepperCurrentLabel';

/** @component */
export { ProgressStepperCurrentLabel };